module.exports = __webpack_public_path__ + "static/media/20.23cbeba0.jpg";